export default "__VITE_ASSET__CyU4EOHI__"